import { KImage, KText } from '@/ui-library/components';
import { Flex } from '@chakra-ui/react';
import { memo } from 'react';
import { components } from 'react-select';

export const SchInterviewerOption = memo((props) => {
  // @ts-expect-error -- pre-existing type debt (extraction move)
  const { data, label } = props || {};
  const { avatar, week_interview_hours, week_interview_hours_limit } =
    data || {};

  return (
    <components.Option {...props}>
      <Flex
        gap="5px"
        alignItems="center"
        justifyContent="space-between"
        overflow="hidden"
        flex={1}
      >
        <KImage src={avatar} name={label} />
        <KText flex={1} maxWidth="100%" flexShrink={1} isTruncated>
          {label}
        </KText>
        <KText flexShrink={0}>
          {week_interview_hours}
          {week_interview_hours_limit
            ? ` / ${week_interview_hours_limit}`
            : ''}{' '}
          hrs
        </KText>
      </Flex>
    </components.Option>
  );
});

SchInterviewerOption.displayName = 'SchInterviewerOption';
